export const localStorageNameHistorical = {
    infoUsuario: 'infoUsuario',
    procedimientoActual: 'procedimientoActual',
    convocatoriaSeleccionada: 'convocatoriaSeleccionada',
    solicitudColaborativa: 'solicitudColaborativa',
    perfilSeleccionado: 'perfilSeleccionado',
    flagAvisosCriticos: 'flagAvisosCriticos',
    misTramites: 'misTramites',
    misTramitesVphone: "misTramitesVphone",
    tipoProcedimientos: 'tipoProcedimientos',
    resourceFormNuevaSolicitud: 'ov3-formulariogenerico',
    solicitudActual: 'solicitudActual',
    formularioSolicitud: 'formularioSolicitud',
    pdfSolicitud: 'pdfSolicitud',
    recibi: 'recibi',
    numRegistroAries: 'numRegistroAries',
    idExpTrewa: 'idExpTrewa',
    fase: 'fase',
    estado: 'estado',
    protectedRoute: 'protectedRoute',
    convocatoriasProcedimientoPCT: 'convocatoriasProcedimientoPCT',
    urlProcedenciaProcedimiento: 'urlProcedenciaProcedimiento',
    faseEstadoExpediente: 'faseEstadoExpediente',
    loginOut: 'loginOut',
    accesoBandejaSol: 'accesoBandejaSol',
    numeroExpediente: 'numeroExpediente',
    idExpediente: 'idExpediente',
    desestimiento: 'desestimiento',
    accionModificar: 'accionModificar',
    idFase: 'idFase',
    idEstadoFase: 'idEstadoFase',
    entidadSeleccionada: 'entidadSeleccionada',
    entidadesDeAlta: 'entidadesDeAlta',
    accion: 'accion',
    organismo: 'organismo'
}